import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { EmployeeReviewStatus } from '../../meta-data/constants/employee-review-status.enum';
import { EmployeeReviewEntity } from '../../meta-data/performancemanagement-meta-data.service';
import { RoEthosUserEntity, AppMetaDataItemNames, EmsUserExtendedEntity } from '../../../../meta-data/app-meta-data.service';
import { DwDateTimeInputOptions, DwMenuActionType, DwMenuService, DwMetaDataRoutingService, DwSecurityUserService } from '@devwareapps/devware-cap';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeReviewSummaryStatus } from '../../meta-data/constants/employee-review-summary-status.enum';
import { ConfigService } from '../../../../../environments/environment';
import { PerformanceManagementRepositoryService } from '../../services/performance-management-repository.service';
import { WachterUserExt } from '../../../../shared/models/wachter-user.model';

@Component({
  selector: 'app-employee-review-card',
  templateUrl: './employee-review-card.component.html',
  styleUrls: ['./employee-review-card.component.scss'],
  encapsulation : ViewEncapsulation.None
})
export class EmployeeReviewCardComponent implements OnInit, OnChanges {
  @Input() ethosUser: RoEthosUserEntity;
  @Input() employeeReview: EmployeeReviewEntity;
  
  private Supervisor_Eval_Menu_Key = "114";
  private Employee_Eval_Menu_Key = "115";
  //private Employee_EMS = "115";

  private Employee_Review_Summary_Menu_Key = "129";

  
  dateOptions: DwDateTimeInputOptions = {
    minDate: {
      isToday: true,
    }
  }

  
  isReadOnly: boolean = false;
  showEvalButton: boolean = false;
  
  SUBMITTED_STATUS = EmployeeReviewStatus.submitted;
  //@Input() employeeNameDisplay: string;

  @Output() employeeReviewChange = new EventEmitter<EmployeeReviewEntity>();

  employeeHeadingDisplay: string = 'Employee';

  showEmployeeEval: boolean = false;
  showSupervisorEval: boolean = false;

  defaultImageUrl: string = '/assets/img/user-avatar-original.png';
  employeeImageUrl: string = '/assets/img/user-avatar-original.png';
  showEmployeeEMS: boolean;
  emsUserExtended: EmsUserExtendedEntity;

  constructor(private router: Router, private dwMenuService: DwMenuService, private dwMetaDataRoutingService: DwMetaDataRoutingService, private route: ActivatedRoute, private perfMonRepo: PerformanceManagementRepositoryService, private dwSecurityUserService: DwSecurityUserService) { }
  

  ngOnInit(): void {
    this.setupComponent();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.employeeReview?.firstChange == false) {
      this.setupComponent();
    }
  }

  reviewUpdate() {
    this.employeeReviewChange.emit(this.employeeReview);
  }

  gotoEval(middleClick?: boolean) {
    const routeKey = this.employeeReview.IsSupervisorReview ? this.Supervisor_Eval_Menu_Key : this.Employee_Eval_Menu_Key;

    const menu = this.dwMenuService.getMenuByKey(routeKey);

    if (!menu) {
      console.warn(`Route not found for route key ${routeKey}`);
      return;
    }

    let url = menu.url
      .replace(':EmployeeReviewSummaryId', this.employeeReview.EmployeeReviewSummaryId.toString())
      .replace(':EmployeeReviewId', this.employeeReview.EmployeeReviewId.toString());

    if (middleClick) {
      window.open(url, '_blank');
    } else {
      this.router.navigateByUrl(url);
    }
  }

  gotoEMS(middleClick?: boolean) {
    if (!this.emsUserExtended) {
      return;
    }

    // Build EMS Link
    const url = this.dwMetaDataRoutingService.buildEditOrViewUrlWithKey(this.route, AppMetaDataItemNames.EmsUserExtended, this.emsUserExtended?.UserExtendedId, DwMenuActionType.edit);

    if (middleClick) {
      window.open(url, '_blank');
    } else {
      this.router.navigateByUrl(url);
    }
  }

  private setupComponent() {

    if (!this.employeeReview) {
      return;
    }
    this.employeeImageUrl = ConfigService.config.apiRoot + "/trust/ProfilePic?userId=" + this.ethosUser.UserId;

    if (this.employeeReview.IsSupervisorReview) {
      this.showSupervisorEval = true;
      this.employeeHeadingDisplay = 'Supervisor';
    } else {
      if (this.employeeReview?.EmployeeReviewStatusId == EmployeeReviewStatus.submitted ||
        this.employeeReview?.EmployeeReviewStatusId == EmployeeReviewStatus.complete) {
        this.showEmployeeEval = true;
      }
    }

    if (this.employeeReview?.EmployeeReviewStatusId == EmployeeReviewStatus.submitted ||
      this.employeeReview?.EmployeeReviewStatusId == EmployeeReviewStatus.complete) {
      this.isReadOnly = true;
    }

    if (this.dwMenuService.menuState.currentMenu?.menuKey == this.Employee_Review_Summary_Menu_Key) {
      this.showEmployeeEval = false;
      this.showSupervisorEval = false;

      return;
    }
    
    if (!this.employeeReview.IsSupervisorReview) {
      this.setupEMSLInk();
      
    }
    
  }
  setupEMSLInk() {
    this.showEmployeeEMS = false;

    this.perfMonRepo.canAccessEmsExtenededUser()
        .subscribe(canViewEmsExtendedUser => {
          if (canViewEmsExtendedUser) {
            this.perfMonRepo.loadEMSExtendedUser(this.ethosUser.UserId)
            .subscribe(emsUserExtended => {
              if (emsUserExtended?.UserExtendedId) {
                this.showEmployeeEMS = true;
                this.emsUserExtended = emsUserExtended;
              }
            });
          }

        });
  }

}
